'use client';

import { useAppContext } from '@/context/app';
import clsx from 'clsx';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';

const GlobalBackToTop = () => {
  const lastScrollUpRef = useRef(0);
  const prevWillScrollUp = useRef(false);
  const [isWillScrollUp, setIsWillScrollUp] = useState(false);
  const pathname = usePathname();
  const hideBtn = pathname === '/cart' || pathname === '/checkout';
  const [{ headerOnTop }] = useAppContext();

  useEffect(() => {
    if (hideBtn) return;

    const scrollHandler = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const nextWillScrollUp = scrollTop < lastScrollUpRef.current;
      lastScrollUpRef.current = scrollTop;

      if (nextWillScrollUp === prevWillScrollUp.current) {
        return;
      }

      setIsWillScrollUp(nextWillScrollUp);
      prevWillScrollUp.current = nextWillScrollUp;
    };

    scrollHandler();
    document.addEventListener('scroll', scrollHandler);

    return () => {
      document.removeEventListener('scroll', scrollHandler);
    };
  }, [hideBtn]);

  return hideBtn || headerOnTop ? null : (
    <button
      type='button'
      className={clsx(
        'fixed bottom-[90px] right-6 z-40 h-10 w-10 items-center justify-center rounded-[50%] bg-white shadow-md',
        isWillScrollUp ? 'flex' : 'hidden',
      )}
      onClick={() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }}
    >
      <svg
        viewBox='0 0 16 10'
        className='h-auto w-5'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8 2.29188L14.8471 9.30566L15.9205 8.25783L8 0.144593L0.0795317 8.25783L1.15287 9.30566L8 2.29188Z'
          fill='#80583F'
        ></path>
      </svg>
    </button>
  );
};

export default GlobalBackToTop;
